import MonoRail from '@mindful-web/marko-web-theme-monorail/browser';
import ContactUs from '@mindful-web/marko-web-contact-us/browser';

export default (Browser) => {
  MonoRail(Browser, { enableOmedaIdentityX: false });
  ContactUs(Browser);
};
